import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserService } from '../user/user.service';
import { switchMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {

  constructor(private http: HttpClient, private userService: UserService) {}

  downloadDocument(documentId: number, formId: number, headersData: any) {
    const token = localStorage.getItem('id_token');
  
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'message-id': crypto.randomUUID(),
      'document-type': headersData.entityDocType,
      'document-number': headersData.entityDocNumber,
      'user-document-type': headersData.userDocType,
      'user-document-number': headersData.userDocNumber
    });
  
    const url = `${environment.downLoadUrl}?documentId=${encodeURIComponent(documentId)}&formId=${encodeURIComponent(formId)}`;

    return this.http.get<any>(url, { headers });
  }
  
  generateBatchDocuments(file: File, menuId: string, userHeaders: any) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('menu-id', menuId);

    const headers = new HttpHeaders({
      Authorization: `Bearer ${localStorage.getItem('id_token')}`,
      'message-id': crypto.randomUUID(),
      'document-type': userHeaders['custom:tipoDocEntidad'],
      'document-number': userHeaders['custom:numeroDocEntidad'],
      'user-document-type': userHeaders['custom:tipoDoc'],
      'user-document-number': userHeaders['custom:numeroDoc']
    });

    return this.http.post<any>(environment.batchUrl, formData, { headers });
  }

  generateDocument(formData: any, menuId: string): Observable<any> {
    const idToken = localStorage.getItem('id_token');
  
    const baseHeaders = new HttpHeaders({
      Authorization: `Bearer ${idToken}`,
      'Content-Type': 'application/json'
    });
  
    return this.userService.getUserInfo().pipe(
      switchMap((userInfo) => {
        const customHeaders = baseHeaders
          .set('message-id', crypto.randomUUID())
          .set('document-type', userInfo['custom:tipoDocEntidad'])
          .set('document-number', userInfo['custom:numeroDocEntidad'])
          .set('user-document-type', userInfo['custom:tipoDoc'])
          .set('user-document-number', userInfo['custom:numeroDoc']);
  
        const payload = {
          menuId: menuId,
          formData: formData
        };
  
        return this.http.post(environment.generateDocumentUrl, payload, {
          headers: customHeaders
        });
      })
    );
  }
  
  saveForm(formData: any, menuId: string): Observable<any> {
    const idToken = localStorage.getItem('id_token');
    const accessToken = localStorage.getItem('access_token');
  
    const headers = new HttpHeaders({
      Authorization: `Bearer ${idToken}`,
      'Content-Type': 'application/json'
    });
  
    return this.userService.getUserInfo().pipe(
      switchMap(userInfo => {
        const customHeaders = headers
          .set('message-id', crypto.randomUUID())
          .set('document-type', userInfo['custom:tipoDocEntidad'])
          .set('document-number', userInfo['custom:numeroDocEntidad'])
          .set('user-document-type', userInfo['custom:tipoDoc'])
          .set('user-document-number', userInfo['custom:numeroDoc']);
  
        const body = {
          menuId,
          formData
        };
  
        return this.http.post(environment.saveFormUrl, body, { headers: customHeaders });
      })
    );
  }

  getFormData(formId: string, menuId: string): Observable<any> {
    const idToken = localStorage.getItem('id_token');
  
    return this.userService.getUserInfo().pipe(
      switchMap(user => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${idToken}`,
          'message-id': crypto.randomUUID(),
          'document-type': user['custom:tipoDocEntidad'],
          'document-number': user['custom:numeroDocEntidad'],
          'user-document-type': user['custom:tipoDoc'],
          'user-document-number': user['custom:numeroDoc']
        });

        const url = `${environment.modifyDocumentUrl}?formId=${encodeURIComponent(formId)}&menuId=${encodeURIComponent(menuId)}`;

        return this.http.get(url, { headers });
      })
    );
  }
  
  
  
  

}
  